<template>
    <div>
        <div class="tariff-table">
            <slot name="rows"></slot>
        </div>

        <d-button color="black" @click="$modal.show('tariffs')">Подробнее</d-button>

        <d-modal
            v-cloak
            name="tariffs"
            popup-title="Тарифы и условия"
            size="v"
        >
            <slot name="rows"></slot>
        </d-modal>
    </div>
</template>

<script>
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';

export default {
    name: 'TariffsTable',
    components: {
        DButton
    }

}
</script>

<style lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .tariff-table {
        @include fluid('margin-bottom', 32px, 24px);

        & ._hidden-in-short-table {
            display: none;
        }

        & ._title-280 {
            @include mobile {
                width: 100%!important;
            }
        }
    }

    [class*="v-modal"] {
        & .documentation-item__icon {
            background-color: $grey-106;
        }
    }
</style>
